export class EarthPressuresData {

    constructor(calculation, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.calculation = calculation ?? null;
        this.earthPressuresModelInterval = data.earthPressuresModelInterval ?? null;
        this.sigmaZGeosTotTop = data.sigmaZGeosTotTop ?? null;
        this.sigmaZGeosTotIncrement = data.sigmaZGeosTotIncrement ?? null;
        this.sigmaZGeosTotBottom = data.sigmaZGeosTotBottom ?? null;
        this.sigmaZLoadTop = data.sigmaZLoadTop ?? null;
        this.sigmaZLoadIncrement = data.sigmaZLoadIncrement ?? null;
        this.sigmaZLoadBottom = data.sigmaZLoadBottom ?? null;
        this.sigmaZTotTop = data.sigmaZTotTop ?? null;
        this.sigmaZTotIncrement = data.sigmaZTotIncrement ?? null;
        this.sigmaZTotBottom = data.sigmaZTotBottom ?? null;
        this.sigmaZGeosEffTop = data.sigmaZGeosEffTop ?? null;
        this.sigmaZGeosEffIncrement = data.sigmaZGeosEffIncrement ?? null;
        this.sigmaZGeosEffBottom = data.sigmaZGeosEffBottom ?? null;
        this.sigmaZEffTop = data.sigmaZEffTop ?? null;
        this.sigmaZEffIncrement = data.sigmaZEffIncrement ?? null;
        this.sigmaZEffBottom = data.sigmaZEffBottom ?? null;
        this.sigmaXLoadTop = data.sigmaXLoadTop ?? null;
        this.sigmaXLoadIncrement = data.sigmaXLoadIncrement ?? null;
        this.sigmaXLoadBottom = data.sigmaXLoadBottom ?? null;
        this.waterIntervalPressureUxTop = data.waterIntervalPressureUxTop ?? null;
        this.waterIntervalPressureUxIncrement = data.waterIntervalPressureUxIncrement ?? null;
        this.waterIntervalPressureUxBottom = data.waterIntervalPressureUxBottom ?? null;
        this.sigmaXGeosEffTop = data.sigmaXGeosEffTop ?? null;
        this.sigmaXGeosEffIncrement = data.sigmaXGeosEffIncrement ?? null;
        this.sigmaXGeosEffBottom = data.sigmaXGeosEffBottom ?? null;
        this.sigmaXGeosTotTop = data.sigmaXGeosTotTop ?? null;
        this.sigmaXGeosTotIncrement = data.sigmaXGeosTotIncrement ?? null;
        this.sigmaXGeosTotBottom = data.sigmaXGeosTotBottom ?? null;
        this.sigmaXEffTop = data.sigmaXEffTop ?? null;
        this.sigmaXEffIncrement = data.sigmaXEffIncrement ?? null;
        this.sigmaXEffBottom = data.sigmaXEffBottom ?? null;
        this.sigmaXTotTop = data.sigmaXTotTop ?? null;
        this.sigmaXTotIncrement = data.sigmaXTotIncrement ?? null;
        this.sigmaXTotBottom = data.sigmaXTotBottom ?? null;

    }

    get modelInterval() {
        return this.earthPressuresModelInterval?.modelInterval ?? null;
    }

    get modelSection() {
        return this.modelInterval?.modelSection ?? null;
    }

    get isModelSectionMassTopInterval() {
        return this.modelInterval?.isModelSectionMassTopInterval ?? null;
    }

    get elevationTop() {
        return this.modelInterval?.elevationTop ?? null;
    }

    get elevationBottom() {
        return this.modelSection?.elevationBottom ?? null;
    }

    get thickness() {
        return this.modelSection?.thickness ?? null;
    }

    get isModelSectionTopInterval() {
        return this.modelSection?.isModelSectionTopInterval ?? null;
    }

    get isModelSectionBottomInterval() {
        return this.modelSection?.isModelSectionBottomInterval ?? null;
    }

    get waterBody() {
        return this.modelInterval?.waterBody ?? null;
    }

    get waterBodyType() {
        return this.waterBody?.waterBodyType ?? null;
    }

    get waterUnitWeightGamaW() {
        return this.waterBody?.waterUnitWeightGamaW ?? null;
    }

    get coefficientOfSidePressureKWater() {
        return this.waterBody?.coefficientOfSidePressureKWater ?? null;
    }

    get isWithinWaterBody() {
        return this.modelInterval?.isWithinWaterBody ?? null;
    }

    get isWithinWaterBodyAndHasBuoyancyEffect() {
        return this.modelInterval?.isWithinWaterBodyAndHasBuoyancyEffect ?? null;
    }

    get waterIntervalPressureUzTop() {
        return this.modelInterval?.waterIntervalPressureUzTop ?? null;
    }

    get waterIntervalIncreaseUzInc() {
        return this.modelInterval?.waterIntervalIncreaseUzInc ?? null;
    }

    get waterIntervalPressureUzBottom() {
        return this.modelInterval?.waterIntervalPressureUzBottom ?? null;
    }

    get geoType() {
        return this.modelInterval?.geoType ?? null;
    }

    get k0CalcMethod() {
        return this.geoType?.k0CalcMethod ?? null;
    }

    get coefficientOfLateralEarthPressureAtRestK0() {
        return this.geoType?.coefficientOfLateralEarthPressureAtRestK0 ?? null;
    }

    get load() {
        return this.modelInterval?.load ?? null;
    }

    get continuousUniformVerticalLoadP() {
        return this.load?.continuousUniformVerticalLoadP ?? null;
    }

    get soilUnitWeightGama() {
        return this.earthPressuresModelInterval?.soilUnitWeightGama ?? null;
    }

}
